/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { VisualizationHistogramTimePoint } from '../models/VisualizationHistogramTimePoint';

/**
* The source storage category
*/
export class VisualizationHistogramSeries {
  /**
  * The name of the series
  */
  'name': string;
  'data': Array<VisualizationHistogramTimePoint>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "data",
      "baseName": "data",
      "type": "Array<VisualizationHistogramTimePoint>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return VisualizationHistogramSeries.attributeTypeMap;
  }

  public constructor() {
  }
}

